module.exports = __webpack_public_path__ + "static/img/award3.ae6df77.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award3.png
// module id = HwOz
// module chunks = 7